// https://stackoverflow.com/questions/14432571/control-html5-validation-balloon-scroll
$_GP.formInvalidScroll = function (form) {
	form = form instanceof jQuery ? form : $(form);
	if (!form.length) return;
	const container = $('html, body');

	form.find('[required]').on('invalid', function () {
		var windowHeight = $(window).height();
		var windowQuarter = windowHeight / 5;
		var invalidDistTop = form.find('input:invalid, textarea:invalid, select:invalid').first().offset().top - windowQuarter;

		if (invalidDistTop > window.pageYOffset && invalidDistTop < (window.pageYOffset + windowHeight - windowQuarter)) {
			return true;
		} else {
			container.scrollTop(invalidDistTop);
		}
	});
};
